import BaseModel from '../base/BaseModel.model';
import ExpectedResult from './expectedResult.model';
import AnalyticalMatrixEvaluation from '../analyticalMatrixEvaluation.model';
export default class EspecificObjective extends BaseModel {

   public  especificObjetive?: string;

   public showExpectResult?:boolean;
   public expectedResults:Array<ExpectedResult> = [];
   public wasAchieved?:boolean;
   public  achivedReason?: string;
   public evaluationModelUI:AnalyticalMatrixEvaluation = null;

    init(){
       this.especificObjetive = '';
       this.showExpectResult = false;
       this.expectedResults = [];
       this.wasAchieve = false;
       this.achivedReason = '';
    }

}